<div class="bg-iceberg h-5/6 mt-20">
  <span class="p-10 flex justify-center items-center text-black font-black uppercase"> Questionários </span>

  <div class="grid grid-cols-1 grid-rows-2 gap-5">
    <div class="text-chathams-blue flex flex-row items-center">
      <span class="block w-12 h-12 ml-5 border-8 border-white rounded-full bg-status-success"></span>
      <span class="text-chathams-blue ml-4 font-bold font-weight: 700 text-lg">20 Ativos</span>
    </div>
    <div class="text-chathams-blue flex flex-row items-center">
      <span class="block w-12 h-12 ml-5 border-8 border-white rounded-full bg-cerise-red"></span>
      <span class="text-chathams-blue ml-4 font-bold font-weight: 700 text-lg">10 Inativos</span>
    </div>
  </div>
</div>
